import { GET_BRANDS, GET_SINGLE_BRAND, RESET_BRAND } from "./types";

const initialState = {
  brands: [],
  brand: null,
  loading: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };

    case GET_SINGLE_BRAND:
      return {
        ...state,
        brand: action.payload,
      };
    case RESET_BRAND:
      return {
        ...state,
        brand: null,
      };

    default:
      return state;
  }
};
